import { BaseRestDataProvider } from './BaseRestDataProvider';

export interface Team {
  id?: string;
  name: string;
  description?: string;
}

export class TeamDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/teams');
  }

  getAll(): Promise<Team[]> {
    return this.get<Team[]>(``);
  }

  getById(id: string): Promise<Team> {
    return this.get<Team>(`/${id}`);
  }

  create(team: Team): Promise<Team> {
    return this.post<Team>(``, team);
  }

  update(id: string, team: Team): Promise<void> {
    return this.put<void>(`/${id}`, team);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}
